import { Controller } from "@hotwired/stimulus";

/**
 * Tier Toggle Controller
 *
 * Hides flat fee/radius fields when tiers exist.
 * The tiers section is always visible.
 *
 * Targets:
 * - flatFields: elements to hide when tiers exist
 * - field: individual tier rows (used for counting)
 */
export default class extends Controller {
  static targets = ["flatFields", "field"];

  fieldTargetConnected() {
    this.toggle();
  }

  fieldTargetDisconnected() {
    this.toggle();
  }

  toggle() {
    const hasTiers = this.visibleTierCount() > 0;

    this.flatFieldsTargets.forEach((el) => {
      el.classList.toggle("hidden", hasTiers);
      el.querySelectorAll("input").forEach((input) => {
        if (input.dataset.originalDisabled === undefined) {
          input.dataset.originalDisabled =
            input.disabled ? "true" : "false";
        }

        if (hasTiers) {
          input.disabled = true;
        } else {
          input.disabled =
            input.dataset.originalDisabled === "true";
        }
      });
    });
  }

  visibleTierCount() {
    return this.fieldTargets.filter(
      (el) => el.style.display !== "none"
    ).length;
  }
}
